import * as THREE from "three";

import { DatumVisibility, DEFAULT_DATUM_VISIBILITY } from "../base-type";

/**
 * Resolve the partial `visibility` configuration against the defaults and
 * apply it to the datum's 2D and 3D sub-element maps. Returns the resolved
 * `{ plan, model }` so callers can stash it on private backing fields used
 * by `profileView` / `modelView` getters.
 */
export function applyVisibility(
  subElements2D: Map<string, THREE.Object3D>,
  subElements3D: Map<string, THREE.Object3D>,
  visibility: DatumVisibility | undefined,
): { plan: boolean; model: boolean } {
  const resolved: Required<DatumVisibility> = {
    ...DEFAULT_DATUM_VISIBILITY,
    ...(visibility ?? {}),
  };
  for (const obj of subElements2D.values()) obj.visible = resolved.plan;
  for (const obj of subElements3D.values()) obj.visible = resolved.model;
  return resolved;
}

export function setProfileView(
  subElements2D: Map<string, THREE.Object3D>,
  value: boolean,
): void {
  for (const obj of subElements2D.values()) obj.visible = value;
}

export function setModelView(
  subElements3D: Map<string, THREE.Object3D>,
  value: boolean,
): void {
  for (const obj of subElements3D.values()) obj.visible = value;
}
